import React from "react";
import { Helmet } from 'react-helmet';
import Hero from "./hero";
import ReviewsCarousel from "../includes/reviewsCarousel";
import Beliefs from "./beliefs";
import Team from "./team";

const About = () => {
    const aboutPageSchema = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "@id": "https://www.partneredmg.com/about#webpage",
        "url": "https://www.partneredmg.com/about",
        "name": "About Us | Partnered Management Group — PMP-Certified Fractional PM Team",
        "description": "Meet the Partnered Management Group team: PMP-certified project managers, operations leaders, and strategists with 40+ years of combined experience helping small and mid-sized businesses deliver results.",
        "isPartOf": { "@id": "https://www.partneredmg.com/#website" },
        "about": { "@id": "https://www.partneredmg.com/#organization" },
        "breadcrumb": { "@id": "https://www.partneredmg.com/about#breadcrumb" }
    };

    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.partneredmg.com/"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "About",
                "item": "https://www.partneredmg.com/about"
            }
        ]
    };

    const teamSchema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "Partnered Management Group Leadership Team",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "item": {
                    "@type": "Person",
                    "name": "August Shah",
                    "jobTitle": "President & Founder",
                    "worksFor": { "@id": "https://www.partneredmg.com/#organization" },
                    "description": "Founder of Partnered Management Group. Software Engineer and Technical Project Manager with experience as Director of Product and Director of Technology for digital agencies.",
                    "url": "https://www.partneredmg.com/about",
                    "sameAs": "https://www.linkedin.com/company/partneredmg",
                    "knowsAbout": ["Project Management", "Software Engineering", "Technical Product Management", "Digital Agencies", "Fractional Services"]
                }
            },
{
                "@type": "ListItem",
                "position": 2,
                "item": {
                    "@type": "Person",
                    "name": "Erica Lester",
                    "jobTitle": "Director of Strategy & Growth",
                    "worksFor": { "@id": "https://www.partneredmg.com/#organization" },
                    "description": "20+ years in project management across government, technology, creative, and education. PMP and CBAP certified.",
                    "url": "https://www.partneredmg.com/about",
                    "hasCredential": [
                        { "@type": "EducationalOccupationalCredential", "name": "Project Management Professional (PMP)", "credentialCategory": "Professional Certification" },
                        { "@type": "EducationalOccupationalCredential", "name": "Certified Business Analysis Professional (CBAP)", "credentialCategory": "Professional Certification" }
                    ],
                    "knowsAbout": ["PMO Frameworks", "Government Programs", "Technology Modernization", "Business Analysis", "Change Management"]
                }
            },
            {
                "@type": "ListItem",
                "position": 3,
                "item": {
                    "@type": "Person",
                    "name": "Kamari Patrick",
                    "jobTitle": "Director of Project Management",
                    "worksFor": { "@id": "https://www.partneredmg.com/#organization" },
                    "description": "10+ years in government, healthcare, and EdTech. PMI Agile Certified Practitioner and Pragmatic Certified Product Manager.",
                    "url": "https://www.partneredmg.com/about",
                    "hasCredential": [
                        { "@type": "EducationalOccupationalCredential", "name": "PMI Agile Certified Practitioner (PMI-ACP)", "credentialCategory": "Professional Certification" },
                        { "@type": "EducationalOccupationalCredential", "name": "Pragmatic Certified Product Manager", "credentialCategory": "Professional Certification" }
                    ],
                    "knowsAbout": ["Agile Project Management", "Product Management", "Healthcare IT", "EdTech", "User Research", "Roadmap Execution"]
                }
            },
            {
                "@type": "ListItem",
                "position": 4,
                "item": {
                    "@type": "Person",
                    "name": "Leah Recasner",
                    "jobTitle": "Director of Culture & Talent",
                    "worksFor": { "@id": "https://www.partneredmg.com/#organization" },
                    "description": "Ed.D. in Educational Leadership. Specializes in culture, talent development, and team alignment.",
                    "url": "https://www.partneredmg.com/about",
                    "hasCredential": [
                        { "@type": "EducationalOccupationalCredential", "name": "Doctor of Education (Ed.D.) in Educational Leadership", "credentialCategory": "Degree" }
                    ],
                    "knowsAbout": ["Organizational Culture", "Talent Development", "Team Alignment", "Educational Leadership", "Facilitation"]
                }
            }
        ]
    };

    return (
        <div>
            <Helmet>
                <title>About Us | Partnered Management Group — PMP-Certified Fractional PM Team</title>
                <meta name="description" content="Meet the Partnered Management Group team: PMP-certified project managers, operations leaders, and strategists with 40+ years of combined experience helping small and mid-sized businesses deliver results." />
                <link rel="canonical" href="https://www.partneredmg.com/about" />
                <meta property="og:title" content="About Partnered Management Group | Our Team & Mission" />
                <meta property="og:description" content="Meet the PMG team: PMP-certified project managers and operations leaders with 40+ years of combined experience helping businesses deliver results." />
                <meta property="og:url" content="https://www.partneredmg.com/about" />
                <meta property="og:type" content="website" />
                <script type="application/ld+json">{JSON.stringify(aboutPageSchema)}</script>
                <script type="application/ld+json">{JSON.stringify(teamSchema)}</script>
                <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
            </Helmet>
            <Hero />
            <ReviewsCarousel />
            <Beliefs />
            <Team />
        </div>
    )
}

export default About;